var _rect, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEEFEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_2959",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#002953"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_2959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8037 9.54822C20.6272 8.99706 21.7319 9.04261 22.5088 9.68494L22.6699 9.8324L22.6787 9.84021H22.6777L22.8174 9.99548L22.8252 10.0043C23.5032 10.8365 23.5028 12.0368 22.8242 12.8685L22.8174 12.8773H22.8164L22.6777 13.0316L22.6689 13.0404L12.54 23.1683C11.6539 24.0542 10.2171 24.0543 9.33105 23.1683C8.44497 22.2822 8.44514 20.8455 9.33105 19.9594L19.46 9.83142L19.4678 9.82263H19.4688L19.623 9.68298L19.6318 9.67615L19.8037 9.54822Z",
    fill: "#FE8F8F",
    stroke: "#FF0000",
    strokeWidth: 0.458333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33105 9.83142C10.2171 8.94539 11.6539 8.9456 12.54 9.83142L22.6689 19.9594L22.6777 19.9681L22.8164 20.1224L22.8242 20.1312L22.9434 20.2914C23.5008 21.1125 23.4604 22.2172 22.8232 22.9974L22.8164 23.0062L22.6768 23.1605L22.668 23.1693C21.8369 23.9992 20.5228 24.0503 19.6318 23.3236L19.623 23.3168L19.4688 23.1771L19.46 23.1683L9.33105 13.0404C8.44514 12.1543 8.445 10.7175 9.33105 9.83142Z",
    fill: "#FF0000",
    stroke: "#FE8F8F",
    strokeWidth: 0.458333
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.9ff6321b5225e5511675b6f3acabd5a4.svg";
export { ForwardRef as ReactComponent };